import type { TourStep } from "./OnboardingTour";

export const dashboardTourSteps: TourStep[] = [
  {
    id: "welcome",
    target: "#tour-welcome",
    title: "\uD83D\uDC4B Welcome to Vexis",
    content: "This is your recruitment dashboard. Let\u2019s take 60 seconds to show you how it works.",
    placement: "bottom",
  },
  {
    id: "invite-candidate",
    target: "#tour-invite-candidate",
    title: "Step 1 \u2014 Invite a Candidate",
    content: "Start here. Enter a candidate\u2019s details and send them a video assessment link. They complete it in under 15 minutes on any device \u2014 no app needed.",
    placement: "bottom",
  },
  {
    id: "pipeline",
    target: "#tour-pipeline",
    title: "Step 2 \u2014 Track Your Pipeline",
    content: "Every candidate moves through your pipeline automatically. AI scores their responses and moves them to the right stage. You review and decide.",
    placement: "right",
  },
  {
    id: "dossier",
    target: "#tour-dossier",
    title: "Step 3 \u2014 Review the Dossier",
    content: "Once AI scoring is complete, a boardroom-ready candidate dossier is generated automatically. Share it with your client in one click.",
    placement: "left",
  },
  {
    id: "settings",
    target: "#tour-settings",
    title: "Step 4 \u2014 Configure Your Settings",
    content: "Connect your ATS, set up your sending email and SMS, and customise your assessment templates here.",
    placement: "right",
  },
  {
    id: "help",
    target: "#tour-help",
    title: "You\u2019re ready to go \uD83D\uDE80",
    content: "Click this button any time to replay this tour. If you need help, contact us at support@vexistalentagency.com",
    placement: "left",
  },
];
